import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { EnterprisePaymentProfileService } from 'apps/portal/services/EnterprisePaymentProfileService';

const ACTIVE_MANDATE_KEY = 'portal-active-mandate';

export const useDefaultPaymentMethod = (enterpriseId: number | null | undefined) =>
  useQuery({
    queryKey: ['portal-default-payment-method', enterpriseId],
    queryFn: () =>
      EnterprisePaymentProfileService.getDefaultPaymentMethod({ enterpriseId: enterpriseId! }),
    enabled: !!enterpriseId,
  });

export const useActiveMandate = (
  enterpriseId: number | null | undefined,
  userPaymentMethodId: number | null | undefined,
  enabled = true,
) =>
  useQuery({
    queryKey: [ACTIVE_MANDATE_KEY, enterpriseId, userPaymentMethodId],
    queryFn: () =>
      EnterprisePaymentProfileService.getActiveMandate({
        enterpriseId: enterpriseId!,
        userPaymentMethodId: userPaymentMethodId!,
      }),
    enabled: enabled && !!enterpriseId && !!userPaymentMethodId,
  });

export const useAcceptMandate = (enterpriseId: number | null | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userPaymentMethodId: number) =>
      EnterprisePaymentProfileService.acceptMandate({
        enterpriseId: enterpriseId!,
        userPaymentMethodId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ACTIVE_MANDATE_KEY] });
    },
  });
};
